import React, { useMemo } from 'react';
import { SalesPerson } from '../../../core/types/SalesPerson.model';
import { getMeetingDateStr } from '../../../utils/dateUtils';
import { useData } from '../../../core/contexts/DataContext';
import { SalesPersonsPreviewBio } from './SalesPersonsPreviewBio';


interface SalesPersonsPreviewProps {
    salesPerson: SalesPerson;
    selectedDate: string;
    handleSalesPersonSelect: (salesPerson: SalesPerson) => void;
    selectedSalesPerson?: SalesPerson;
}

const SalesPersonsPreview: React.FC<SalesPersonsPreviewProps> =
    ({ salesPerson, selectedDate, handleSalesPersonSelect, selectedSalesPerson }) => {

        const { exhibitors } = useData();
        const availableSlots = useMemo(() => {
            if (!salesPerson?.meetings) return 0;

            const salesPersonFromExhibitor = exhibitors.find(ex => ex.salesPersons.some(sp => sp.id === salesPerson.id))?.salesPersons.find(sp => sp.id === salesPerson.id);
            return salesPersonFromExhibitor?.meetings?.filter(
                (slot) =>
                    slot.status === "Available" &&
                    getMeetingDateStr(slot.startTime) === selectedDate
            ).length || 0;
        }, [salesPerson, selectedDate, exhibitors]);

        return (
            <div className="col-md-6 col-lg-4" key={salesPerson.id}>
                <div
                    className={`card h-100 ${selectedSalesPerson?.id === salesPerson.id ? 'selected' : ''
                        }`}
                >
                    <div className="card-body"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleSalesPersonSelect(salesPerson)}>
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <h6 className="card-title fw-semibold text-dark mb-1">
                                    {salesPerson.fullName}
                                </h6>
                            </div>
                            <div className="text-end">
                                <div className="text-success small fw-medium">
                                    {availableSlots} slots available
                                </div>
                            </div>
                        </div>
                    </div>
                    {salesPerson.bio && (
                        <div className="pt-2 pb-2 ps-3 pe-3 border-top">
                            <div className="d-flex align-items-center gap-2 ">
                                <SalesPersonsPreviewBio text={salesPerson.bio} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }

export default SalesPersonsPreview;